import { render, staticRenderFns } from "./4_contribution.vue?vue&type=template&id=447350bc&scoped=true&"
import script from "./4_contribution.vue?vue&type=script&lang=js&"
export * from "./4_contribution.vue?vue&type=script&lang=js&"
import style0 from "./4_contribution.vue?vue&type=style&index=0&id=447350bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447350bc",
  null
  
)

export default component.exports